import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BuildingMetadataComponentAbstract } from '../../metadata-components/building-metadata/building-metadata.component.abstract';

@Component({
  selector: 'app-building-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './building-metadata-v2.component.html',
})
export class BuildingMetadataV2Component extends BuildingMetadataComponentAbstract {}
